import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Home from 'pages/Home';
import OverviewFlow from 'pages/OverviewFlow';
import NotEligible from 'pages/NotEligible';
import { ContactInformation } from 'pages/ContactInformation';
import { Consent } from 'pages/Consent';
import { MedicalInformation } from 'pages/MedicalInformation';
import CreateAccount from 'pages/CreateAccount';
import NoPkd from 'pages/NoPkd';
import SelectDiagnosis from 'pages/SelectDiagnosis';
import SignIn from 'pages/SignIn';
import Dashboard from 'pages/Dashboard';
import ForgotPassword from 'pages/SignIn/ForgotPassword';
import PersonalCalendar from 'pages/PersonalCalendar';
import { MyData } from 'pages/MyData';
import MyTasks from 'pages/MyTasks';
import { RegistryDashboard } from 'pages/RegistryDashboard';
import MyAccount from 'pages/MyAccount';
import CareSummary from 'pages/CareSummary';
import AddCareCenter from 'pages/MyCareNetwork/AddCareCenter';
import CareCenterAdded from 'pages/MyCareNetwork/CareCenterAdded';
import MyCareNetwork from 'pages/MyCareNetwork';
import PulseSurvey from 'pages/PulseSurvey';
import PrivateRoute, {
  CompletedSecondaryOverviewRoute,
  DashboardProtectedRoute,
} from './route.private';
import DashboardHome from 'pages/DashboardHome';
import CTEReport from 'pages/CTEReport';
import Questionnaire from 'pages/Questionnaire';
import { MedicalInfo, ContactInfo } from './route.utils';
import { useScrollToTop } from 'hooks/useScrollToTop';
import NotFound from 'pages/NotFound';
import Welcome from 'pages/Welcome';
import Auth0EmailUnblock from 'pages/Auth0EmailUnblock';

const ConfirmEmail = lazy(() => import('pages/ConfirmEmail'));
const EmailVerified = lazy(() => import('pages/EmailVerified'));

export const PKDRoutes = () => {
  useScrollToTop();
  return (
    <Routes>
      <Route
        path='/' element={<Navigate
          to='/sign-in' replace
        />}
      />
      <Route
        path='overview-flow' element={<OverviewFlow />}
      />
      <Route
        path='not-eligible' element={<NotEligible />}
      />
      <Route
        path='i-do-not-have-pkd' element={<NoPkd />}
      />
      <Route
        path='create-account' element={<CreateAccount />}
      />
      <Route
        path='select-diagnosis' element={<SelectDiagnosis />}
      />
      <Route
        path='sign-in' element={<SignIn />}
      />
      <Route
        path='email-verified' element={<EmailVerified />}
      />
      <Route
        path='auth0-emailunblock' element={<Auth0EmailUnblock />}
      />
      <Route
        element={<PrivateRoute />}>
        <Route
          path='welcome' element={<Welcome />}
        />
        <Route
          path='verify-email' element={<ConfirmEmail />}
        />
        <Route
          element={<CompletedSecondaryOverviewRoute />}>
          <Route
            path={MedicalInfo} element={<MedicalInformation />}
          />
          <Route
            path={ContactInfo} element={<ContactInformation />}
          />
        </Route>
        <Route
          path='consent' element={<Consent />}
        />
        <Route
          element={<DashboardProtectedRoute />}>
          <Route
            path='homepage' element={<Dashboard />}>
            <Route
              path='registry' element={<RegistryDashboard />}
            />
            <Route
              index element={<DashboardHome />}
            />
            <Route
              path='personal-calendar' element={<PersonalCalendar />}
            />
            <Route
              path='clinical-study-eligibility-report'
              element={<CTEReport />}
            />
            <Route
              path='my-data-making-a-difference' element={<MyData />}
            />
          </Route>
        </Route>
        <Route
          path='questionnaire/:id' element={<Questionnaire />}
        />
        <Route
          path='care-summary' element={<CareSummary />}
        />
        <Route
          path='my-account' element={<MyAccount />}
        />
        <Route
          path='my-care-network'>
          <Route
            index element={<MyCareNetwork />}
          />
          <Route
            path='add-care-center' element={<AddCareCenter />}
          />
          <Route
            path='care-center-added' element={<CareCenterAdded />}
          />
        </Route>
        <Route
          path='my-tasks' element={<MyTasks />}
        />
        <Route
          path='forgot-password' element={<ForgotPassword />}
        />
        <Route
          path='pulse-survey' element={<PulseSurvey />}
        />
      </Route>
      <Route
        path='*' element={<NotFound />}
      />
    </Routes>
  );
};

export default PKDRoutes;
